import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, provideExperimentalZonelessChangeDetection } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
//import {provideNativeDateAdapter} from '@angular/material/core';
import {MatNativeDateModule} from '@angular/material/core';

import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
//import { ImageCropperModule } from 'ngx-image-cropper';
import { ApiAuthorizationModule } from 'src/api-authorization/api-authorization.module';
import { AuthorizeGuard } from 'src/api-authorization/authorize.guard';
import { AuthorizeInterceptor } from 'src/api-authorization/authorize.interceptor';
import { TournamentPlayerPipe } from 'src/pipes/player.pipe';
import { SafeUrlPipe } from 'src/pipes/SafeUrl.pipe';
import { TournamentScorePipe } from 'src/pipes/score.pipe';
import { CustomInterceptorAddLadderLevel } from 'src/services/httpinterceptor.ladderlevel';
import { ByNamePipe, ByNamePipeRank } from '../pipes/filtername.pipe';
import { AdminEmailComponent } from './admin/email/email.component';
import { AdminImpersonateComponent } from './admin/impersonate/impersonate.component';
import { AdminDialogSetLevelComponent } from './admin/paid/dialogAdminSetLevel.component';
import { AdminPaidComponent } from './admin/paid/paid.component';
import { AdminPairingComponent } from './admin/pairing/pairing.component';
import { AdminRecordComponent } from './admin/record/record.component';
import { AdminTournamentComponent } from './admin/tournament/tournament.component';
import { AdminTournamentBuilderComponent } from './admin/tourney/tourneybuilder.component';
import { AdminCreateUserComponent } from './admin/users/users.component';
import { AllScoresComponent } from './allscores/allscores.component';
import { AllTournamentComponent } from './alltournament/alltournament.component';
import { AppComponent } from './app.component';
import { AvatarBigComponent } from './avatarbig/avatarbig.component';
import { ChangeLadderLevelComponent } from './changeladderlevel/ladderlevel.component';
import { ClearCookiesComponent } from './clearcookies/clearcookies.component';
import { DialogDoublesNameComponent } from './dialogs/dialogChangeDoublesName.component';
import { DialogUserMessageComponent } from './dialogs/dialogUserMessage.component';
import { AppFooterComponent } from './footer/footer.component';
import { HistoryComponent } from './history/history.component';
import { HomeComponent } from './home/home.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { TiebreakSignupComponent } from './next-tiebreaker/tiebreaksignup.component';
import { NextLadderComponent } from './nextladder/nextladder.component';
import { PlayerComponent } from './player/player.component';
import { PlayersComponent } from './players/players.component';
import { ProfileComponent } from './profile/profile.component';
import { RecordTiebreakMatchComponent } from './record-tiebreak/record.component';
import { RecordMatchTournamentComponent } from './record-tournament/record.component';
import { RecordMatchComponent } from './record/record.component';
import { RoundsComponent } from './rounds/rounds.component';
import { ScoresComponent } from './scores/scores.component';
import { TiebreakGridComponent } from './tiebreakgrid/tiebreakgrid.component';
import { TournamentComponent } from './tournament/tournament.component';
import { WifmComponent } from './wifm/wifm.component';
import { WifmUploadComponent } from './wifm/wifmupload.component';
import { AdminDialogSetLadderComponent } from './admin/paid/dialogAdminSetLadder.component';
import { PreloginComponent } from './prelogin/prelogin.component';
import { AdminSetRankComponent } from './admin/setrank/setrank.component';
import { BulkEmailComponent } from './players/bulkemail.component';
import { SuperAllScoresComponent } from './superallscores/superallscores.component';
import { AdminPrintPlayerListComponent } from './admin/printplayerlist/printplayerlist.component';
import { AdminAddLadderComponent } from './admin/addladder/addladder.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { AdminPairDoublesComponent } from './admin/pairdoubles/pairdoubles.component';
import { JFriedmanLoginComponent } from './jfriedman/login.component';
import { JFriedmanLoggedInComponent } from './jfriedman/loggedin.component';
import { ArtificialIntelligenceRulesComponent } from './artificialintelligencerules/artificialintelligencerules.component';




@NgModule({
  declarations: [
    AllScoresComponent,
    SuperAllScoresComponent,
    AppComponent,
    AppFooterComponent,
    AvatarBigComponent,
    ChangeLadderLevelComponent,
    ClearCookiesComponent,
    DialogUserMessageComponent,
    DialogDoublesNameComponent,

    HistoryComponent,
    HomeComponent,
    PreloginComponent,
    NavMenuComponent,
    NextLadderComponent,
    TiebreakSignupComponent,
    PlayerComponent,
    PlayersComponent,
    BulkEmailComponent,
    ProfileComponent,
    RecordMatchComponent,
    RecordTiebreakMatchComponent,
    RecordMatchTournamentComponent,
    RoundsComponent,
    ScoresComponent,
    TournamentComponent,
    TiebreakGridComponent,
    AllTournamentComponent,
    ArtificialIntelligenceRulesComponent,


    WifmComponent,
    WifmUploadComponent,

    JFriedmanLoginComponent,
    JFriedmanLoggedInComponent,

    TournamentPlayerPipe,
    TournamentScorePipe,
    SafeUrlPipe, // to allow phone numbers to click SMS:
    ByNamePipe,
    ByNamePipeRank,

    AdminPairingComponent,  // split into Admin Module 
    AdminTournamentBuilderComponent,
    AdminPairDoublesComponent,
    AdminPrintPlayerListComponent,
    AdminCreateUserComponent,
    AdminEmailComponent,
    AdminImpersonateComponent,
    AdminPaidComponent,
    AdminTournamentComponent,
    AdminDialogSetLevelComponent,
    AdminDialogSetLadderComponent,
    AdminSetRankComponent,
    AdminRecordComponent,
    AdminAddLadderComponent
  ],
  // entryComponents: [
  //   DialogUserMessageComponent,  // not needed in angular 9
  //   DialogDoublesNameComponent,
  //   AdminDialogSetLevelComponent,
  //   AdminDialogSetLadderComponent
  // ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ApiAuthorizationModule,
    FontAwesomeModule,
    ImageCropperComponent,
    MatDialogModule,
//rt {ChangeDetectionStrategy, Component} from '@angular/core';
MatDatepickerModule,
MatNativeDateModule,
MatFormFieldModule,
MatInputModule,
//MatInputModule} from '@angular/material/input';
//MatFormFieldModule} from '@angular/material/form-field';
    NoopAnimationsModule,

    RouterModule.forRoot([
      { path: '', component: PreloginComponent, pathMatch: 'full' },
      { path: 'home', component: HomeComponent, canActivate: [AuthorizeGuard] },
      { path: 'record', component: RecordMatchComponent, canActivate: [AuthorizeGuard] },
      { path: 'record-tiebreak', component: RecordTiebreakMatchComponent, canActivate: [AuthorizeGuard] },
      { path: 'record-tournament', component: RecordMatchTournamentComponent, canActivate: [AuthorizeGuard] },
      // this is looking at someone else
      { path: 'player/:playerId', component: PlayerComponent, canActivate: [AuthorizeGuard] },
      { path: 'avatarbig/:playerId', component: AvatarBigComponent, canActivate: [AuthorizeGuard] },
      // this is looking at phones and emails
      { path: 'players', component: PlayersComponent, canActivate: [AuthorizeGuard] },
      { path: 'scores', component: ScoresComponent, canActivate: [AuthorizeGuard] },
      { path: 'allscores', component: AllScoresComponent, canActivate: [AuthorizeGuard] },
      { path: 'superallscores', component: SuperAllScoresComponent, canActivate: [AuthorizeGuard] },
      { path: 'tournament', component: TournamentComponent, canActivate: [AuthorizeGuard] },
      { path: 'tournament/:ladderId', component: TournamentComponent, canActivate: [AuthorizeGuard] },
      { path: 'alltournament', component: AllTournamentComponent, canActivate: [AuthorizeGuard] },
      { path: 'ladderlevel', component: ChangeLadderLevelComponent, canActivate: [AuthorizeGuard] },
      { path: 'nextladder', component: NextLadderComponent, canActivate: [AuthorizeGuard] },
      { path: 'tiebreaksignup', component: TiebreakSignupComponent, canActivate: [AuthorizeGuard] },
      { path: 'history', component: HistoryComponent, canActivate: [AuthorizeGuard] },
      { path: 'profile', component: ProfileComponent, canActivate: [AuthorizeGuard] },
      { path: 'rounds', component: RoundsComponent, canActivate: [AuthorizeGuard] },
      { path: 'tiebreakgrid', component: TiebreakGridComponent, canActivate: [AuthorizeGuard] },
      { path: 'wifm', component: WifmComponent, canActivate: [AuthorizeGuard] },
      { path: 'wifm-upload', component: WifmUploadComponent, canActivate: [AuthorizeGuard] },
      { path: 'clear', component: ClearCookiesComponent },
      { path: 'ai',
        children: [
          { path: 'rules', component: ArtificialIntelligenceRulesComponent, canActivate: [AuthorizeGuard] }
          
        ]
      },
      {
        path: 'admin',
        children: [
          { path: 'pairing', component: AdminPairingComponent, canActivate: [AuthorizeGuard] },
          { path: 'tourney', component: AdminTournamentBuilderComponent, canActivate: [AuthorizeGuard] },
          { path: 'pairdoubles', component: AdminPairDoublesComponent, canActivate: [AuthorizeGuard] },
          { path: 'printplayers', component: AdminPrintPlayerListComponent, canActivate: [AuthorizeGuard] },
          { path: 'users', component: AdminCreateUserComponent, canActivate: [AuthorizeGuard] },
          { path: 'impersonate', component: AdminImpersonateComponent, canActivate: [AuthorizeGuard] },
          { path: 'setrank', component: AdminSetRankComponent, canActivate: [AuthorizeGuard] },
          //{ path: 'tournament', component: AdminTournamentComponent, canActivate: [AuthorizeGuard] },
          { path: 'paid', component: AdminPaidComponent, canActivate: [AuthorizeGuard] },
          { path: 'record', component: AdminRecordComponent, canActivate: [AuthorizeGuard] },
          { path: 'email', component: AdminEmailComponent, canActivate: [AuthorizeGuard] },
          { path: 'addladder', component: AdminAddLadderComponent, canActivate: [AuthorizeGuard] }
        ]
      },
      {
        path: 'jfriedman', 
        children: [
          { path: 'login', component: JFriedmanLoginComponent, canActivate: [AuthorizeGuard] },
          { path: 'loggedin', component: JFriedmanLoggedInComponent, canActivate: [AuthorizeGuard] }
        ]
      }

    ], { scrollPositionRestoration: 'top' })
  ],
  providers: [
    //provideExperimentalZonelessChangeDetection(), // Add this line
    { provide: HTTP_INTERCEPTORS, useClass: AuthorizeInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CustomInterceptorAddLadderLevel, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
